module.exports = __webpack_public_path__ + "static/img/85040D_4_C_20230615_fit.22720bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/85040D_4_C_20230615_fit.png
// module id = 2XBN
// module chunks = 0